import { MacaroonVariant } from "./MacaroonVariant.js";

export const macaroonVariantColorMap: Record<MacaroonVariant, string> = {
	[MacaroonVariant.Chocolate]: "bg-[#966346] text-black",
	[MacaroonVariant.SaltedCaramel]: "bg-[#E0A45D] text-black",
	[MacaroonVariant.Pistachio]: "bg-[#ABCE73] text-black",
	[MacaroonVariant.Raspberry]: "bg-[#FF808F] text-black",
	[MacaroonVariant.Lemon]: "bg-[#FFE869] text-black",
};
